import { Subject } from 'rxjs';

const subject = new Subject();

export const editCommentService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};